import { Autocomplete } from '@wajeez-web/components/mui';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import {
  DefaultInputTypeV2,
  ModalSelectInput,
} from '@wajeez-web/components/ui';

import { FormInputController } from '../FormInputController';
import { SelectFormTypeV2 } from '../Types';

export interface FormModalSelectV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    DefaultInputTypeV2 {
  fieldMeta: SelectFormTypeV2;
  validationErrorMessages?: Partial<{
    required: string;
  }>;
  readOnly?: boolean;
  onSearch?: (searchText: string | undefined) => void;
  onRender?: () => void | Promise<void>;
}

export const FormModalSelectV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormModalSelectV2Props<TFormFields>) => {
  const { label, ...otherProps } = props;

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <ModalSelectInput
          options={fieldMeta.fieldOptions?.selectOptions || []}
          defaultOptions={fieldMeta.fieldOptions?.defaultOptions || []}
          label={fieldMeta.label}
          {...controllerProps}
          {...otherProps}
        />
      )}
      {...props}
    />
  );
};
